import { render } from "./Workflow.vue?vue&type=template&id=24a9d524&scoped=true"
import script from "./Workflow.vue?vue&type=script&lang=js"
export * from "./Workflow.vue?vue&type=script&lang=js"

import "./Workflow.vue?vue&type=style&index=0&id=24a9d524&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a9d524"]])

export default __exports__